"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * capitalize all letters of a string
 *
 * @example
 * capitalizeAll('some word') => 'SOME WORD'
 */
var capitalizeAll = function capitalizeAll(str) {
  if ((0, _isNotString.default)(str)) return '';
  return str.toUpperCase();
};
var _default = exports.default = capitalizeAll;